export type SchoolId =
  "highres" | "behavior" | "grid" | "relative" | "fieldrel";

export function pickedSubtitle(pointShaped: boolean): string {
  return pointShaped
    ? "Choose How to Interpolate Between Your Points"
    : "Pick How to Interpret Your Zones";
}

export function pickedCaption(id: SchoolId): string {
  switch (id) {
    case "behavior":
      return "Categorize by the Wetness, Productivity, and Fertility of Each Zone";
    case "relative":
      return "Work With Each Zone Fully Independently";
    case "fieldrel":
      return "Work With Each Zone Fully Independently";
    case "highres":
      return "Use AI to See What Happens Between Points";
    case "grid":
      return "Use Simple Spatial Interpolation";
  }
}
